export const columns = (view: string) => [
  {
    key: 'order_date',
    label: 'Date',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'order_id',
    label: 'Order ID',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'customer_name',
    label: 'Customer',
    headerStyle: 'min-w-200px',
    isSorted: true,
  },
  {
    key: 'sales_rep_name',
    label: 'Representative',
    headerStyle: 'min-w-200px',
    isSorted: true,
  },
  {
    key: 'order_status',
    label: 'Status',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'total_inc_tax',
    label: 'Total',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'updated_by',
    label: 'Last updated by',
    headerStyle: 'min-w-175px',
    isSorted: false,
  },
  {
    key: 'updated_at',
    label: 'Last updated date',
    headerStyle: 'min-w-175px',
    isSorted: false,
  },
  {
    key: 'archived_by',
    label: 'Archived by',
    headerStyle: `min-w-175px ${view === 'archived' ? '' : 'd-none'}`,
    isSorted: false,
  },
  {
    key: 'note',
    label: 'Note',
    headerStyle: `min-w-300px ${view === 'archived' ? '' : 'd-none'}`,
    isSorted: false,
  },
  {
    key: 'action',
    label: 'Action',
    headerStyle: 'w-80px',
    isSorted: false,
  },
]